import React, { useState } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import NavSubmenu from './NavSubmenu';

const Nav = ({ content, toggleMobileMenu }) => {
  const [showSubmenu, setShowSubmenu] = useState(null);
  let keepLastIndex = -1;
  const hideSubmenu = index => {
    if (keepLastIndex === index) {
      keepLastIndex = showSubmenu;
      setShowSubmenu(null);
    } else {
      keepLastIndex = showSubmenu;
      setShowSubmenu(index);
    }
  };
  const viewSubmenu = index => {
    setShowSubmenu(index);
  };

  return (
    <nav className="main-menu-nav">
      <ul className="main-menu-nav-list">
        {content
          ? content.map((item, menuIndex) => {
              return (
                <li key={menuIndex} className="main-menu-list-item has-dropdown">
                  {window.innerWidth > 1025 ? (
                    <Link className="main-menu-list-item-link" onMouseEnter={() => viewSubmenu(menuIndex)} onMouseLeave={() => hideSubmenu(-1)} onClick={() => hideSubmenu(-1)} to={item.linkTo}>
                      {item.linkName}
                    </Link>
                  ) : (
                    <Link className="main-menu-list-item-link" onMouseEnter={() => viewSubmenu(menuIndex)} onMouseLeave={() => hideSubmenu(menuIndex)} onClick={() => hideSubmenu(menuIndex)} to="#">
                      {item.linkName}
                    </Link>
                  )}

                  <div
                    onClick={() => hideSubmenu(-1)}
                    onMouseEnter={() => viewSubmenu(menuIndex)}
                    onMouseLeave={() => hideSubmenu(-1)}
                    className={`${showSubmenu === menuIndex ? 'open-submenu' : ''} submenu-controller`}
                  >
                    <NavSubmenu content={item.submenu} toggleMobileMenu={toggleMobileMenu} hideSubmenu={hideSubmenu} />
                  </div>
                </li>
              );
            })
          : null}
      </ul>
    </nav>
  );
};
export default Nav;

// CSS Structure
/*
.main-menu-nav{
  .main-menu-nav-list{
    .main-menu-list-item{
      .main-menu-link{
      }
      &.has-dropdown{
       .main-menu-link{
       }
      }
    }
  }
  .submenu-wrapper{
  .container{
    .submenu-title-group{
      .submenu-title{
      }
    }
    .submenu-list{
      .submenu-item{
        .submenu-link{
        }
        &.btn-wrapper{
          &.btn-default{
          }
        }
      }
    }
    .contact-us-wrapper{
      .contact-us-link{
        .contact-us-content{
          .assist-text{
          }
          .phone-img-wrapper{
          }
          .phone-icon-img{
          }
          .contact-us-rep-img{
          }
        }
        .contact-us-img-bg{
        }
      }
    }
  }
}
}
*/
